import {hashStringSHA256, isOfflineHost} from "./globalUtils";

import { EventListener } from "./eventVerteiler";
import { CookieConsentHandler } from "./cookieconsent/cookieHandler";
import { CookieHandler } from "./cookieconsent/cookieHandler";

//declare const gtag;

/**
 * @classdesc Eine Klasse, die eine URL entgegen nimmt und dann ein Google Tracking absetzt
 * @class
 * @param {string}      domain        Die Domain auf der wir tracken wollen
 * @param {string}      sport
 * @param {string}      produkt
 *
 */
export const LOOPTRACKINGEVENTNAMES = {
    KONFI_OPEN : {name: "view_configurator", id: "C00"},
    KONFI_SELECT_DESIGN : {name: "configurator_select_design", id: "C01"},
    KONFI_SELECT_READY : {name: "configurator_ready_designs", id: "C02"},
    KONFI_TOOLBOX : {name: "configurator_toolbox", id: "C03"},
    KONFI_SELECT_COLOR : {name: "configurator_select_colour", id: "C04"},
    KONFI_ADD_TEXT : {name: "configurator_add_text", id: "C05"},
    KONFI_ADD_LOGO : {name: "configurator_add_logo", id: "C06"},
    KONFI_ADD_TO_CART : {name: "add_to_cart", id: "C07"},
    KONFI_SUBMIT_KONTAKT : {name: "submit_contact_form_configurator", id: "C10"},
    KONFI_SUBMIT_DESIGNCHECK : {name: "submit_design_check", id: "C08"},
    KONFI_SUBMIT_DESIGNWISH : {name: "submit_design_wish", id: "C09"},
    KONFI_MENU_SELECT : {name: "navigation_configurator", id: "C11"},
    KONFI_OPEN_PRICE_DELIVERY : {name: "configurator_open_price_delivery", id: "C12"},
    KONFI_REQUEST_PRICE_DELIVERY : {name: "configurator_request_price_delivery", id: "C13"},
    CART_OPEN : {name: "view_cart", id: "I01"},
    CART_REMOVE : {name: "remove_from_cart", id: "I02"},
    CART_REDEEM_COUPON : {name: "redeem_coupon", id: "I03"},
    CART_PRODUCTION_TYPE : {name: "production_type", id: "I04"},
    CART_SHIPPING : {name: "shipping", id: "I05"},
    CART_BEGIN_CHECKOUT : {name: "begin_checkout", id: "I06"},
    CART_ADD_SHIPPING_INFO : {name: "add_shipping_info", id: "I07"},
    CART_ADD_PAYMENT_INFO : {name: "add_payment_info", id: "I08"},
    CART_DESIGN_CHECK : {name: "design_check", id: "I09"},
    CART_CONFIRM_ORDER : {name: "confirm_order", id: "I10"},
    CART_PURCHASE : {name: "purchase", id: "I11"},
    CART_CHANGE_ITEM : {name: "change_item", id: "I12"},
    CART_CONFIRM_ADDRESS : {name: "confirm_selected_address", id: "I13"},
    CART_REFUND: {name: "refund", id: "I14"},
    ACCOUNT_LOGIN : {name: "login", id: "K01"},
    ACCOUNT_SIGNUP : {name: "sign_up", id: "K02"}
};

export const Shoppingcart_LOOPTRACKINGEVENTNAMES = [
    LOOPTRACKINGEVENTNAMES.CART_REMOVE,
    LOOPTRACKINGEVENTNAMES.CART_REDEEM_COUPON,
    LOOPTRACKINGEVENTNAMES.CART_PRODUCTION_TYPE,
    LOOPTRACKINGEVENTNAMES.CART_SHIPPING,
    LOOPTRACKINGEVENTNAMES.CART_BEGIN_CHECKOUT,
    LOOPTRACKINGEVENTNAMES.CART_ADD_SHIPPING_INFO,
    LOOPTRACKINGEVENTNAMES.CART_ADD_PAYMENT_INFO,
    LOOPTRACKINGEVENTNAMES.CART_DESIGN_CHECK,
    LOOPTRACKINGEVENTNAMES.CART_CONFIRM_ORDER,
    LOOPTRACKINGEVENTNAMES.CART_PURCHASE,
    LOOPTRACKINGEVENTNAMES.CART_CHANGE_ITEM,
    LOOPTRACKINGEVENTNAMES.CART_CONFIRM_ADDRESS,
    LOOPTRACKINGEVENTNAMES.CART_REFUND
];


export const LOOPTRACKINGSTATUS = {
    CART_OPEN : "view_cart",
    CART_ADD_SHIPPING_INFO: "add_shipping_info",
    CART_CHANGE_ITEM: "change_item"
}

export class CartItem{
    public item_id: string;
    public item_name: string;
    public currency: string;
    public discount:  number;
    public item_category1: string;
    public item_category2: string;
    public item_category3: string;
    public price: number;
    public quantity: number;

    /*Forgot - to be implemented*/
    public coupon: string;
}

export class EventPayload{
    public currency: string;
    public value: number;
    public coupon: string;
    public shipping_tier: string;
    public payment_type: string;
    public transaction_id: String;
    public tax: number;
    public shipping: number;
    public user_email: string;
    public items: CartItem[];

    constructor() {
        this.items = [];
    }
}

export class UserDataPayLoad{
    public user_email: string;
}

export class LoopTrackingObject{
    public event_id: string;
    public event_name: string;
    public event_params: Record<string, any>[];
    public event_payload: EventPayload;
    public user_data_payload: UserDataPayLoad;

    constructor(data: {name:string, id:string}) {
        this.event_id = data.id;
        this.event_name = data.name;
        this.event_params = [];
    }

    public getObjectAsJsonString(): string{
        const baseOutput = {
            event: "event",
            event_id: this.event_id,
            event_name: this.event_name,
        };

        const eventParams = this.event_params.length > 0 ?
            this.event_params.flatMap(paramObj => Object.entries(paramObj))
            .reduce((accumulator, [key, value], index) => ({
                ...accumulator,
                [`event_parameter_name_${index + 1}`]: key,
                [`event_parameter_value_${index + 1}`]: value,
            }), {}) : {};

        const eventPayload = this.event_payload ? {
            event_payload: {
                ...(this.event_payload.currency !== undefined ? { currency: this.event_payload.currency } : {}),
                ...(this.event_payload.value !== undefined ? { value: this.event_payload.value } : {}),
                ...(this.event_payload.coupon !== undefined ? { coupon: this.event_payload.coupon } : {}),
                ...(this.event_payload.shipping_tier !== undefined ? { shipping_tier: this.event_payload.shipping_tier } : {}),
                ...(this.event_payload.payment_type !== undefined ? { payment_type: this.event_payload.payment_type } : {}),
                ...(this.event_payload.transaction_id !== undefined ? { transaction_id: this.event_payload.transaction_id } : {}),
                ...(this.event_payload.tax !== undefined ? { tax: this.event_payload.tax } : {}),
                ...(this.event_payload.shipping !== undefined ? { shipping: this.event_payload.shipping } : {}),
                ...(this.event_payload.user_email !== undefined ? { sha256_user_email: this.event_payload.user_email } : {}),
                items: this.event_payload.items.length > 0 ? this.event_payload.items.map(item => ({
                    item_id: item.item_id,
                    item_name: item.item_name,
                    currency: item.currency,
                    discount: item.discount < 0 ? 0 : item.discount,
                    item_category1: item.item_category1,
                    item_category2: item.item_category2,
                    item_category3: item.item_category3,
                    price: item.price,
                    quantity: Number(item.quantity)
                })) : []
            }
        } : {};

        const userDataPayload = this.user_data_payload ? {
            user_data: {
                sha256_user_email : this.user_data_payload.user_email
            }
        } : {};


        return JSON.stringify({
            ...baseOutput,
            ...eventParams,
            ...eventPayload,
            ...userDataPayload
        }, null, 4);

    }
}

export class LoopTracker extends EventListener {
    private status: string;
    private waiting_events: LoopTrackingObject[];
    private constentAlreadyGranted = false;

    constructor() {
        super();
        this.status = "";
        this.waiting_events = [];
        this.addEventListener("CookieConsentChoiceMadeEvent", () => {
            if (this.constentAlreadyGranted){return;}

            if (CookieConsentHandler.marketingCookiesAllowed()) {
                this.consentGranted();
                this.pushEventList();
            } else {
                CookieHandler.deleteGoogleCookies();
            }
        });
        if(!this.constentAlreadyGranted){
            if (CookieConsentHandler.marketingCookiesAllowed()) {
                this.consentGranted();
                this.pushEventList();
            }
        }
    }

    consentGranted() {
        (window as any).dataLayer.push({
            'event': 'ConsentGiven',
        });
        this.constentAlreadyGranted = true;
    }

    setStatus(status: string) {
        this.status = status;
    }

    getStatus():string {
        return this.status;
    }

    getEventForStatus():any{
        if(this.status===LOOPTRACKINGSTATUS.CART_OPEN){
            return LOOPTRACKINGEVENTNAMES.CART_OPEN;
        }
        if(this.status===LOOPTRACKINGSTATUS.CART_ADD_SHIPPING_INFO){
            return LOOPTRACKINGEVENTNAMES.CART_ADD_SHIPPING_INFO;
        }
        if(this.status===LOOPTRACKINGSTATUS.CART_CHANGE_ITEM){
            return LOOPTRACKINGEVENTNAMES.CART_CHANGE_ITEM;
        }

        return null;
    }

    pushEventList() {
        this.waiting_events.forEach((event) => {
            this.postTrackingObject(event);
        });
        this.waiting_events = [];
    }

    postTrackingObjectOrPushToEventList(trackingObject: LoopTrackingObject) {
        if(this.constentAlreadyGranted){
            this.postTrackingObject(trackingObject);
        }
        else{
            this.waiting_events.push(trackingObject);
        }
    }

    postTrackingObject(trackingObject: LoopTrackingObject) {
        if(isOfflineHost(window.location.hostname)){
            return;
        }
        if ((window as any).dataLayer && (window as any).dataLayer.find(element => element["gtm.start"])){
            if(Shoppingcart_LOOPTRACKINGEVENTNAMES.some(event => event.name === trackingObject.event_name)){
                (window as any).dataLayer.push({
                    'event': 'ConsentGiven',
                });
            }

            (window as any).dataLayer.push(JSON.parse(trackingObject.getObjectAsJsonString()));
            // console.log('push loop to data layer');
            // console.log(trackingObject.getObjectAsJsonString());
        }
        else{
            // console.log(trackingObject.getObjectAsJsonString());
        }
    }

    async trackBasicEvent(data: {name:string, id:string}) {
        try {
            const TrackingObject = new LoopTrackingObject(data);
            this.postTrackingObjectOrPushToEventList(TrackingObject);
        }
        catch (e) {
            console.log("exception happened");
        }
    }

    async trackToolBoxEvent(selectedAction: string) {
        try {
            const TrackingObject = new LoopTrackingObject(LOOPTRACKINGEVENTNAMES.KONFI_TOOLBOX);
            TrackingObject.event_params.push({action: selectedAction});

            this.postTrackingObjectOrPushToEventList(TrackingObject);
        }
        catch (e) {
            console.log("exception happened");
        }
    }

    async trackSelectDesignEvent(designlist: string, design:string) {
        try {
            const TrackingObject = new LoopTrackingObject(LOOPTRACKINGEVENTNAMES.KONFI_SELECT_DESIGN);
            TrackingObject.event_params.push({selected_designlist: designlist, selected_category: design});

            this.postTrackingObjectOrPushToEventList(TrackingObject);
        }
        catch (e) {
            console.log("exception happened");
        }
    }

    async trackLoginEvent(email) {
        try {
            const TrackingObject = new LoopTrackingObject(LOOPTRACKINGEVENTNAMES.ACCOUNT_LOGIN);
            const hashedEmail = await hashStringSHA256(email);

            const UserPayload = new UserDataPayLoad();
            UserPayload.user_email = hashedEmail;
            TrackingObject.user_data_payload = UserPayload;

            const payload = new EventPayload();
            payload.user_email = hashedEmail;
            TrackingObject.event_payload = payload;

            this.postTrackingObjectOrPushToEventList(TrackingObject);
        }
        catch (e) {
            console.log("exception happened");
        }
    }

    async trackSignUpEvent(email) {
        try {
            const TrackingObject = new LoopTrackingObject(LOOPTRACKINGEVENTNAMES.ACCOUNT_SIGNUP);
            TrackingObject.event_params.push({method: "configurator"});
            const hashedEmail = await hashStringSHA256(email);

            const UserPayload = new UserDataPayLoad();
            UserPayload.user_email = hashedEmail;
            TrackingObject.user_data_payload = UserPayload;

            const payload = new EventPayload();
            payload.user_email = hashedEmail;
            TrackingObject.event_payload = payload;

            this.postTrackingObjectOrPushToEventList(TrackingObject);
        }
        catch (e) {
            console.log("exception happened");
        }
    }

    async trackSelectColorEvent(palette: string, color:string) {
        try {
            const TrackingObject = new LoopTrackingObject(LOOPTRACKINGEVENTNAMES.KONFI_SELECT_COLOR);
            TrackingObject.event_params.push({selected_colourpalette: palette, selected_category: color});

            this.postTrackingObjectOrPushToEventList(TrackingObject);
        }
        catch (e) {
            console.log("exception happened");
        }
    }

    async trackPriceAndDeliveryEvent(value: string) {
        try {
            const TrackingObject = new LoopTrackingObject(LOOPTRACKINGEVENTNAMES.KONFI_REQUEST_PRICE_DELIVERY);
            TrackingObject.event_params.push({amount: value});

            this.postTrackingObjectOrPushToEventList(TrackingObject);
        }
        catch (e) {
            console.log("exception happened");
        }
    }

    async trackLinkToEvent(selectedLink:string) {
        try {
            const TrackingObject = new LoopTrackingObject(LOOPTRACKINGEVENTNAMES.KONFI_MENU_SELECT);
            TrackingObject.event_params.push({link_to: selectedLink});

            this.postTrackingObjectOrPushToEventList(TrackingObject);
        }
        catch (e) {
            console.log("exception happened");
        }
    }

    async trackCouponAppliedEvent(coupon: string) {
        try {
            const TrackingObject = new LoopTrackingObject(LOOPTRACKINGEVENTNAMES.CART_REDEEM_COUPON);
            TrackingObject.event_params.push({coupon: coupon});

            this.postTrackingObjectOrPushToEventList(TrackingObject);
        }
        catch (e) {
            console.log("exception happened");
        }
    }

    async trackSingleParameterEvent(data: {name:string, id:string}, value: string) {
        try {
            const TrackingObject = new LoopTrackingObject(data);
            TrackingObject.event_params.push({selected_category: value});

            this.postTrackingObjectOrPushToEventList(TrackingObject);
        }
        catch (e) {
            console.log("exception happened");
        }
    }

    async trackSingleCartItemEvent(data: {name:string, id:string}, currency: string, value: number, item:CartItem) {
        try {
            const TrackingObject = new LoopTrackingObject(data);
            const Payload = new EventPayload();
            Payload.currency = currency;
            Payload.value = value;
            Payload.items.push(item);
            TrackingObject.event_payload = Payload;

            this.postTrackingObjectOrPushToEventList(TrackingObject);
        }
        catch (e) {
            console.log("exception happened");
        }
    }

    async trackCompleteCartEvent(data: {name:string, id:string}, currency: string, value: number, coupon: string, selectedShipping: string, selectedPayment: string, items:CartItem[]) {
        try {
            const TrackingObject = new LoopTrackingObject(data);
            const Payload = new EventPayload();
            Payload.currency = currency;
            Payload.value = value;
            Payload.coupon = coupon;
            Payload.shipping_tier = selectedShipping;
            Payload.payment_type = selectedPayment;
            Payload.items = [...Payload.items, ...items];
            TrackingObject.event_payload = Payload;

            this.postTrackingObjectOrPushToEventList(TrackingObject);
        }
        catch (e) {
            console.log("exception happened");
        }
    }

    async trackBeginCheckoutEvent(currency: string, value: number, coupon: string, items:CartItem[]) {
        try {
            const TrackingObject = new LoopTrackingObject(LOOPTRACKINGEVENTNAMES.CART_BEGIN_CHECKOUT);
            const Payload = new EventPayload();
            Payload.currency = currency;
            Payload.value = value;
            Payload.coupon = coupon;
            Payload.items = [...Payload.items, ...items];
            TrackingObject.event_payload = Payload;

            this.postTrackingObjectOrPushToEventList(TrackingObject);
        }
        catch (e) {
            console.log("exception happened");
        }
    }

    async trackShippingInformationEvent(currency: string, value: number, coupon: string, selectedShipping: string, items:CartItem[]) {
        try {
            const TrackingObject = new LoopTrackingObject(LOOPTRACKINGEVENTNAMES.CART_ADD_SHIPPING_INFO);
            const Payload = new EventPayload();
            Payload.currency = currency;
            Payload.value = value;
            Payload.coupon = coupon;
            Payload.shipping_tier = selectedShipping;
            Payload.items = [...Payload.items, ...items];
            TrackingObject.event_payload = Payload;

            this.postTrackingObjectOrPushToEventList(TrackingObject);
        }
        catch (e) {
            console.log("exception happened");
        }
    }

    async trackPaymentEvent(currency: string, value: number, coupon: string, selectedPayment: string, items:CartItem[]) {
        try {
            const TrackingObject = new LoopTrackingObject(LOOPTRACKINGEVENTNAMES.CART_ADD_PAYMENT_INFO);
            const Payload = new EventPayload();
            Payload.currency = currency;
            Payload.value = value;
            Payload.coupon = coupon;
            Payload.payment_type = selectedPayment;
            Payload.items = [...Payload.items, ...items];
            TrackingObject.event_payload = Payload;

            this.postTrackingObjectOrPushToEventList(TrackingObject);
        }
        catch (e) {
            console.log("exception happened");
        }
    }

    async trackPurchaseEvent(currency: string, value: number, warenkorbID: number, tax: number, shipping: number, email: string, coupon: string, selectedPayment: string, items:CartItem[]) {
        try {
            const TrackingObject = new LoopTrackingObject(LOOPTRACKINGEVENTNAMES.CART_PURCHASE);
            const Payload = new EventPayload();
            Payload.currency = currency;
            Payload.value = value;
            Payload.coupon = coupon;
            Payload.payment_type = selectedPayment;
            Payload.transaction_id = warenkorbID.toString();
            Payload.tax = tax;
            Payload.shipping = shipping;
            Payload.user_email = await hashStringSHA256(email);
            Payload.items = [...Payload.items, ...items];
            TrackingObject.event_payload = Payload;

            this.postTrackingObjectOrPushToEventList(TrackingObject);
        }
        catch (e) {
            console.log("exception happened");
        }
    }

    async trackRefundEvent(currency: string, value: number, warenkorbID: number, tax: number, shipping: number, email: string, coupon: string, items:CartItem[]) {
        try {
            const TrackingObject = new LoopTrackingObject(LOOPTRACKINGEVENTNAMES.CART_REFUND);
            const Payload = new EventPayload();
            Payload.currency = currency;
            Payload.value = value;
            Payload.coupon = coupon;
            Payload.transaction_id = warenkorbID.toString();
            Payload.tax = tax;
            Payload.shipping = shipping;
            Payload.user_email = await hashStringSHA256(email);
            Payload.items = [...Payload.items, ...items];
            TrackingObject.event_payload = Payload;

            this.postTrackingObjectOrPushToEventList(TrackingObject);
        }
        catch (e) {
            console.log("exception happened");
        }
    }
}
